export default {
  getContacts: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/contacts/getters.js